// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__dyQkk","row":"style_row__uTk9m","CTA":"style_CTA__xwDFR"};